<template>
  <!-- 外面包一层div是为了方便控制层级关系，最后用完也需要把它销毁 -->
  <div class="background_wraper" v-if="toastState.click" :class="mask ? 'background_wraper_mask' : ''">
    <!-- 绑定一个全屏点击背景 并加入淡入淡出效果 -->
    <!-- 不同类型提示的最外层 -->
    <div :class="[
      this.toastState.click
        ? 'click_tips_background_active'
        : 'click_tips_background',
      this.toastState.fade ? 'tips_fade_in' : 'fade_out_public'
    ]" @click.stop="backgroundClickHandle">
      <!-- 控制成功对号提示-白底 -->
      <div v-if="type === 1" class="tips_baidi">
        <img src="~assets/img/tips/tips_baidi_chenggong.png" alt />
        <div class="tips_baidi_text">{{ objData }}</div>
      </div>
      <!-- 控制失败叉号提示-白底 -->
      <div v-else-if="type === 2" class="tips_baidi">
        <img src="~assets/img/tips/tips_baidi_shibai.png" alt />
        <div class="tips_baidi_text">{{ objData }}</div>
      </div>
      <!-- 服务器错误消息提示   3     复用的tips1的样式 已经复制过来 -->
      <div v-else-if="type === 3" class="tips1_baidi tips1_huidi">
        <img src="~assets/img/tips/tips1.png" alt />

        <div class="tips1_baidi_text">{{ objData }}</div>
        <!-- <div class="tips1_baidi_text">设计了基于智能手机和GPRS网络的远程家电控制和安防监测系统</div> -->
      </div>
      <!-- 带确认删除和取消返回的 tips  4   删除场景   -->
      <div v-else-if="type === 4" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要删除的场景：{{ objData.sceneName }}</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="clickCancelBtnHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="clickOkBtnHandle(objData, index)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 带确认删除和添加的 tips  5  删除场景规则   -->
      <div v-else-if="type === 5" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要删除或添加的场景规则对象：{{ objData.remark }}</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="click5DeletelBtnHandle(objData, index)">删除</span>
          <span class="tips_btn public_control_btn" @click.stop="click5AddBtnHandle(objData, index)">添加</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 场景包含的设备和下载场景失败时的提示框   6 //代号 20231207-1 组也在使用-->
      <div v-else-if="type === 6" class="tips_toast6_wraper" @click.stop="tipsBaidiBtnHandle">
        <img src="~assets/img/tips/xinxitou.png" alt />
        <div class="tips_toast6_title">关联的设备</div>
        <div class="tips_toast6_text">设备包括：</div>
        <!-- 内容区 -->
        <div class="tips_toast6_context">
          <div class="tips_toast_6_hang" v-for="(value, index) in objData" :key="index">{{ value }}</div>
        </div>

        <div class="tips_toast6_btn" @click="clickCancelBtnHandle">确定并返回</div>
        <!-- <div class="tips_baidi_text">{{objData}}</div> -->
      </div>
      <!-- 场景包含的设备和下载场景失败时的提示框   7-->
      <div v-else-if="type === 7" class="tips_toast6_wraper" @click.stop="tipsBaidiBtnHandle">
        <img src="~assets/img/tips/xinxitou.png" alt />
        <div class="tips_toast6_title">部分设备下载失败！</div>
        <div class="tips_toast6_text">失败的设备包括：</div>
        <!-- 内容区 -->
        <div class="tips_toast6_context">
          <div class="tips_toast_6_hang" v-for="(value, index) in objData" :key="index">{{ value }}</div>
        </div>

        <div class="tips_toast6_btn" @click="clickCancelBtnHandle">确定并返回</div>
        <!-- <div class="tips_baidi_text">{{objData}}</div> -->
      </div>
      <!-- 带确认删除和取消返回的 tips  8  删除子账号   -->
      <div v-else-if="type === 8" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要删除的子账号：{{ objData[index].account }}</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="clickCancelBtnHandle()">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click8QueRenBtnHandle()">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 解绑网关确认的二级弹窗 tips  9    -->
      <div v-else-if="type === 9" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要解绑的网关ID：{{ objData.uniqueCode16 }}</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="backgroundClickHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click9QueRenBtnHandle(objData)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 删除离线设备确认的二级弹窗 tips  10    // 代号 20240124-1-->
      <div v-else-if="type === 10" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <!-- // 代号 20240124-1 -->
        <div class="tips_queren_fanhui_name z_ellipsis1">
          要删除地址{{ objData[index].borderInnerAddress || objData[index].address }}的{{ objData[index].productName }}？
        </div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="backgroundClickHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click10QueRenBtnHandle(objData, index)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 设置和分享页面的弹窗 tips  11    -->
      <div v-else-if="type === 11" class="tips_queren_fanhui tips_baidi tips_11_wraper"
        @click.stop="tipsBaidiBtnHandle">
        <div class="tips11_left_fen_xiang" @click.stop="click11FenXiangBtnHandle(objData)">
          <img src="../../../assets/img/config/shebei_fengxiang.png" alt />
          <span>分享</span>
        </div>
        <div class="tips11_left_fen_xiang" @click.stop="click11ConfigBtnHandle(objData)">
          <img src="../../../assets/img/config/shebei_shezhi.png" alt />
          <span>设置</span>
        </div>
      </div>

      <!-- 带确认删除和取消返回的 tips  12  删除一个A类对象   -->
      <div v-else-if="type === 12" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要删除的对象：{{ objData[index].remark }}</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="backgroundClickHandle()">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click12AddBtnHandle(objData, index)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 是否开启密码保护的 tips  13     -->
      <div v-else-if="type === 13" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <div class="devce_name z_ellipsis1">{{ objData.remark }}</div>
        <div class="devce_name z_ellipsis1">安全保护验证</div>

        <input class="device_config_013_mi_ma_yan_zheng input_public_ime_mode" type="password" placeholder="请输入正确的登录密码"
          v-model="userpassWord" autocomplete="new-password" onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" />

        <div class="btn_wraper">
          <div class="btn_config_013 btn_return public_control_click public_z_index6" @click="backgroundClickHandle">
            返回取消</div>
          <div class="btn_config_013 btn_determine public_control_click public_z_index6" @click="determine13BtnHandle">
            确定密码</div>
        </div>
      </div>

      <!-- 场景设置和分享页面的弹窗 tips  14    -->
      <div v-else-if="type === 14" class="tips_queren_fanhui tips_baidi tips_11_wraper"
        @click.stop="tipsBaidiBtnHandle">
        <div class="tips11_left_fen_xiang" @click.stop="click14FenXiangBtnHandle(objData)">
          <img src="../../../assets/img/config/shebei_fengxiang.png" alt />
          <span>分享</span>
        </div>
        <div class="tips11_left_fen_xiang" @click.stop="click14ConfigBtnHandle(objData)">
          <img src="../../../assets/img/config/shebei_shezhi.png" alt />
          <span>设置</span>
        </div>
      </div>

      <!-- 带确认删除和取消返回的 tips  15  删除027定时任务  -->
      <div v-else-if="type === 15" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要删除该定时任务？</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="clickCancelBtnHandle()">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click15QueRenBtnHandle()">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 场景配置对象加密判断是否允许勾选的 tips  16     -->
      <div v-else-if="type === 16" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <div class="devce_name z_ellipsis1">{{ objData.remark }}</div>
        <div class="devce_name z_ellipsis1">安全保护验证</div>

        <input class="device_config_013_mi_ma_yan_zheng input_public_ime_mode" type="password" placeholder="请输入正确的登录密码"
          v-model="userpassWord" autocomplete="new-password" onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" />

        <div class="btn_wraper">
          <div class="btn_config_013 btn_return public_control_click public_z_index6" @click="backgroundClickHandle">
            返回取消</div>
          <div class="btn_config_013 btn_determine public_control_click public_z_index6" @click="determine16BtnHandle">
            确定密码</div>
        </div>
      </div>

      <!-- 分享的密码判断及确定 tips  17   // 代号 20240130-2 优化了部分文案 -->
      <div v-else-if="type === 17" class="tips_fenxiang_17_tips tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <div class="close_img_top">
          <img src="~assets/img/controlpublic/control-guanbi-chahao.png" @click.stop="backgroundClickHandle" alt />
        </div>
        <!-- // 代号 20240130-2 hasOwnProperty 判断属性是否存在-->
        <div v-if="objData.hasOwnProperty('remark')">{{ objData.remark }}({{ objData.regionName }})</div>
        <div v-else>{{ objData.sceneName }}({{ objData.regionName }})</div>

        <div class="tips_fenxiang_17_tishi">(分享前的设置)</div>

        <div @click.stop="fenXiangPassWordState017BtnHandle()" class="tips_fenxiang_17_tips_jiami">
          <div>分享是否加密？</div>
          <img v-show="fenXiang017.passWordState === 0" src="~assets/img/config/weixuan.png" alt />
          <img v-show="fenXiang017.passWordState === 1" src="~assets/img/config/xuanzhong.png" alt />
        </div>
        <!-- 分享密码输入框 -->
        <input v-show="fenXiang017.passWordState === 1"
          class="device_mi_ma_yan_zheng input_public_ime_mode tips_fenxiang_17_tips_jiami_input" type="text"
          placeholder="请输入分享密码(至少4位，最多24位)" v-model="fenXiang017.passWord" autocomplete="new-password"
          onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" />

        <div class="tips_fenxiang_17_tips_time">
          <div class="tips_fenxiang_17_tips_time_tips">分享的有效时长：</div>
          <!-- 设备延时时间的显示 -->
          <div class="tips_fenxiang_17_tips_time_input">
            <input class="device_mi_ma_yan_zheng device_mi_ma_yan_zheng tips_fenxiang_17_tips_jiami_input"
              placeholder="多少" v-model="fenXiang017.day" type="text" onkeyup="value=value.replace(/[^\d\.]/g,'')" />
            <span>天</span>
            <input class="device_mi_ma_yan_zheng device_mi_ma_yan_zheng tips_fenxiang_17_tips_jiami_input" type="text"
              placeholder="多少" v-model="fenXiang017.hour" onkeyup="value=value.replace(/[^\d\.]/g,'')" />
            <span>小时</span>
          </div>
        </div>
        <div @click.stop="fenXiang17QueRenBtnHandle" class="public_config_que_ren_btn chuang_jian_fen_xiang17_btn">
          创建分享链接</div>
      </div>

      <!-- 分享的密码判断及确定 tips  18   // 代号 20240130-2 优化了部分文案  -->
      <div v-else-if="type === 18" class="tips_fenxiang_18_tips tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <div class="close_img_top">
          <img src="~assets/img/controlpublic/control-guanbi-chahao.png" @click.stop="backgroundClickHandle" alt />
        </div>

        <div>分享给朋友</div>
        <div class="tips_fenxiang_18_tishi">已经生成分享链接:</div>
        <div class="tips_fenxiang_18_link_info">
          <img src="~assets/img/config/fenxiang_lan.png" alt />
          <input class="device_mi_ma_yan_zheng input_public_ime_mode tips_fenxiang_17_tips_jiami_input" type="text"
            placeholder="http" v-model="shareLink" readonly="readonly" />
          <div @click.stop="doCopy(shareLink)" class="public_config_que_ren_btn chuang_jian_fen_xiang18_btn">复制</div>
        </div>

        <div class="tips_fenxiang_18_fengexian"></div>

        <!-- 微信和QQ图标 -->
        <div class="tips_fenxiang_18_fengexian_img_wraper">
          <img @click="imgFenXiangBtnHandle('weixin')" src="~assets/img/config/weixin.png" alt />
          <img @click="imgFenXiangBtnHandle('qq')" src="~assets/img/config/QQ.png" alt />
        </div>
        <!-- <div
          @click.stop="doCopy(fenXiang017.link)"
          class="public_config_que_ren_btn chuang_jian_fen_xiang17_btn"
        >
          关闭并复制到粘贴板
        </div>-->
        <!-- <button type="button" @click.stop="doCopy(fenXiang017.link)">
          Copy!
        </button>-->
      </div>

      <!-- 修改设备地址及替换设备确认的二级弹窗 tips  19  21    -->
      <div v-else-if="type === 19 || type === 21" class="tips_queren_fanhui tips_baidi"
        @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <!-- // 代号 20241212-1 -->
        <div v-if="type === 19" class="tips_queren_fanhui_name z_ellipsis1">
          确定要修改{{ objData.remark }}的地址为{{ objData.borderInnerAddress ? objData.borderInnerAddress : objData.address }}？
        </div>
        <div v-else class="tips_queren_fanhui_name z_ellipsis1">确定要替换地址为{{ objData.borderInnerAddress ?
          objData.borderInnerAddress : objData.address }}的{{ objData.remark }}？
        </div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="backgroundClickHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click19QueRenBtnHandle(objData)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 小程序二维码 tips  20    -->
      <div v-else-if="type === 20" class="tips_fenxiang_20_tips" @click.stop="tipsBaidiBtnHandle">
        <div class="botton_20_appdown_wraper">
          <div class="appdownload2_20_wraper">
            <div class="tips_fenxiang_20_tips_title">微信扫码快捷登录</div>

            <img class="appdownload2_20_img" :src="objData.xiaoChengXuCodeErWeiMa" alt />
            <div class="appdownload2_20_text">小程序快捷登录</div>
          </div>

          <div class="content_text_20_tishi_wraper">
            <div class="tips_fenxiang_20_tips_title">获取最佳体验,扫码下载APP</div>
            <div class="tips_fenxiang_20_tips_content_text">账号：{{ objData.account }}</div>
            <div class="tips_fenxiang_20_tips_content_text">密码：{{ objData.userPassWord }}</div>
          </div>

          <div class="appdownload2_20_wraper">
            <div class="tips_fenxiang_20_tips_title">APP账号密码登录</div>

            <img class="appdownload2_20_img" :src="objData.appUrl" alt />
            <div class="appdownload2_20_text">扫码下载APP</div>
          </div>
        </div>

        <div class="tips_fenxiang_20_tips_content">提示：请您妥善保存该子账号信息,关闭该页面后将无法再次找回。另外，应注意该信息的安全性，如有丢失，请立即更新或删除该子账号。</div>

        <img @click="clickCancelBtnHandle" class="close_img" src="~assets/img/afterAdd/close.png" alt />
      </div>

      <!--  tips  22  删除组内对象   //代号 20231207-1 -->
      <div v-else-if="type === 22" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">确定要删除组内对象：{{ objData.remark }}?</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="backgroundClickHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click22DeletelBtnHandle(objData, index)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>
      <!-- 带确认删除和取消返回的 tips  23   删除组  //代号 20231207-1  -->
      <div v-else-if="type === 23" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>
        <div class="tips_queren_fanhui_name z_ellipsis1">要删除的组：{{ objData.deviceName }}</div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="clickCancelBtnHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="clickOk23BtnHandle(objData, index)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- 修改设备地址及替换设备确认的二级弹窗 tips  24  -->
      <!-- // 代号 20241212-1 -->
      <div v-else-if="type === 24" class="tips_queren_fanhui tips_baidi" @click.stop="tipsBaidiBtnHandle">
        <!-- <div class="scene_control_page"> -->
        <div class="tips_queren_fanhui_title">提示</div>

        <div class="tips_queren_fanhui_name z_ellipsis1">确定要替换地址为{{ objData.query.borderInnerAddress }}的{{
          objData.query.remark }}？
        </div>
        <!-- <div class="scene_control_text">场景确认操作？</div> -->
        <div class="tips_queren_fanhui_btn">
          <span class="tips_btn public_control_btn" @click.stop="backgroundClickHandle">取消</span>
          <span class="tips_btn public_control_btn" @click.stop="click24QueRenBtnHandle(objData)">确认</span>
        </div>
        <!-- 场景控制 -->
        <!-- </div> -->
      </div>

      <!-- --------------------------------- -->
    </div>
  </div>
</template>

<script>
import store from "store/index"; ///导入公共仓库
import { objectClone, throttle } from "common/tool";
import vm from "../../../main";
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge ////设备类型判断
  // deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
import { number } from "echarts/lib/export";
const throttleTime = 500; ///节流防抖时间
export default {
  data() {
    return {
      ServeSceneData: [], ////场景列表指向仓库
      userpassWord: "", /////用户输入的验证密码
      fenXiang017: {
        passWord: "", ////017弹窗使用
        day: "0",
        hour: "1",
        passWordState: 1 ////0未开启密码  1开启密码  默认开启
      },
      shareLink: "" ////018生成的分享链接
    };
  },
  watch: {
    "fenXiang017.day": function (val) {
      // 对象监听对象元素监听
      console.log(val);
      if (Number(val) > 100) {
        this.fenXiang017.day = "100";
        return;
      }
      if (Number(val) < 0 || isNaN(parseInt(val))) {
        this.fenXiang017.day = "0";
        return;
      }
      this.fenXiang017.day = Number(val);
    },
    "fenXiang017.hour": function (val) {
      // 对象监听对象元素监听
      console.log(val);
      if (Number(val) > 23) {
        this.fenXiang017.hour = "23";
        return;
      }
      if (Number(val) < 2 || isNaN(parseInt(val))) {
        this.fenXiang017.hour = "1"; ///最小1个小时
        return;
      }
      this.fenXiang017.hour = Number(val);
    }
  },
  components: {},
  methods: {
    backgroundClickHandle() {
      console.log(this.maskClose);
      if (this.maskClose) {
        console.log("guanbi ");

        this.$closeTipsToast(); ///关闭toast控制弹窗
      }
    },
    clickCancelBtnHandle(value) {
      /// 弹窗的取消按钮
      this.$closeTipsToast(); ///关闭toast控制弹窗
    },
    clickOkBtnHandle(objData, index) {
      console.log(objData);
      // 请求删除场景信息接口，获取数据
      this.$request({
        method: "post",
        url: "/userScene/delUserSceneById",
        data: {
          token: store.state.token,
          sceneId: objData.sceneId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSceneData = res.data.data; ////拿到服务器返回的数据结果
            /// 弹窗的取消按钮
            this.$closeTipsToast(); ///关闭toast控制弹窗
            this.ServeSceneData = store.state.configinfo.ServeSceneData;
            this.ServeSceneData.splice(index, 1);

            this.$showTipsToast(1, "删除成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    tipsBaidiBtnHandle() {
      console.log("阻止事件冒泡");
    },
    click5AddBtnHandle(objData, index) {
      ///添加一条场景规则的的按钮按下了
      throttle(function () {
        //点击事件，节流 防抖函数
        this.$closeTipsToast(); ///关闭toast控制弹窗
        let ServeSceneRule = store.state.configinfo.OneSceneRuleList; ///仓库拿到场景规则LIST
        console.log(ServeSceneRule);

        let tempObjData = {};
        objectClone(tempObjData, objData); ///深度对象克隆
        ServeSceneRule.splice(index, 0, tempObjData);
        console.log(ServeSceneRule);
      }, throttleTime);
    },
    click5DeletelBtnHandle(objData, index) {
      ///删除一条场景规则的的按钮按下了

      console.log(index);
      throttle(function () {
        //点击事件，节流 防抖函数
        this.$closeTipsToast(); ///关闭toast控制弹窗
        let ServeSceneRule = store.state.configinfo.OneSceneRuleList; ///仓库拿到场景规则LIST
        console.log(ServeSceneRule);
        ServeSceneRule.splice(index, 1);

        console.log(ServeSceneRule);
      }, throttleTime);
    },
    click8QueRenBtnHandle() {
      /// 删除子账号接口
      this.$request({
        method: "post",
        url: "/user/delSubAccount",
        data: {
          token: store.state.token,
          account: this.objData[this.index].account ///objData所有子账号的数组列表  index 当前子账号所在的数组位置
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSonAccountData = res.data.data; ////拿到服务器返回的数据结果
            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            this.$closeTipsToast(); ///关闭toast控制弹窗
            // this.objData.splice( this.index , 1 )
            this.$showTipsToast(1, "删除成功", true); ////提示框
            console.log(this.objData);
            console.log(this.index);
            setTimeout(() => {
              this.objData.splice(this.index, 1); ////数据剔除
            }, 500); ////延时一下在删除 是因为 toast弹窗关闭的时候有一个动画延时，如果toats没有关闭就剔除会报错，因为toast用它了
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    click9QueRenBtnHandle(objData) {
      this.$request({
        method: "post",
        url: "/gateway/untieGatewayByGatewayId",
        data: {
          token: store.state.token,
          gatewayId: objData.gatewayId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.$closeTipsToast(); ///关闭toast控制弹窗
            // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
            // 代号 20250202-1 
            if (objData.type && objData.type === "deviceManageChange") {
              // console.log("设备管理页面解绑网关成功!!!!!!!!!!!!!!");
              vm.$router.go(-3);
            }
            else {
              vm.$router.go(-1);
            }
            this.$showTipsToast(1, "解绑成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    click10QueRenBtnHandle(objData, index) {
      ///删除产品 接口，获取数据
      this.$request({
        method: "post",
        url: "/product/delProduct",
        data: {
          token: store.state.token,
          productId: objData[index].productId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果
            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            this.$closeTipsToast(); ///关闭toast控制弹窗
            // 代号 20240124-1 
            setTimeout(() => {
              this.objData.splice(this.index, 1); ////数据剔除
            }, 500); ////延时一下在删除 是因为 toast弹窗关闭的时候有一个动画延时，如果toats没有关闭就剔除会报错，因为toast用它了
            this.$showTipsToast(1, "删除成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    click11ConfigBtnHandle(objData) {
      ////设置按钮被点击了
      this.$closeTipsToast(); ///关闭toast控制弹窗
      if (publicDeviceTypeJudge(objData.productCode, "03", "09", "020")) {
        ///存储vm.$route.path当前页面路径, 用于从设置页面返回到当前主页  // 代号 20240130-1
        store.dispatch("asyUpdataConfigReturnPath", vm.$route.path); ///异步提交
        ////如果是 4键  8键  或F键  跳转的设置页面类型不一样
        vm.$router.push({
          path: "/DeviceManageMain/deviceDetails",
          query: { title: objData.productName, productId: objData.productId }
        });
      }
      else if (objData.isGroup == 1) { //1是组控制
        ///存储vm.$route.path当前页面路径, 用于从设置页面返回到当前主页  // 代号 20240130-1
        store.dispatch("asyUpdataConfigReturnPath", vm.$route.path); ///异步提交
        //代号 20231207-1
        vm.$store.dispatch('asyUpdataOneGroupinfo', objData)
        vm.$router.push({ path: '/ConfigGroupMain/ConfigAddGroup', query: { title: '修改一个组' } })
      }
      else {
        // 获取设备详情 接口，获取数据
        this.$request({
          method: "post",
          url: "/device/findDeviceById",
          data: {
            token: store.state.token,
            deviceId: objData.deviceId
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTips1Toast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              ////、控制成功了 数据地址存到仓库
              store.dispatch("asyUpdataServeOneObjectinfo", res.data.data); ///异步提交对象信息地址到仓库
              ///下面是为了从设置页面返回到进入页面所以需要存一下路径
              ///存储vm.$route.path当前页面路径, 用于从设置页面返回到当前主页  // 代号 20240130-1
              console.log(vm.$route.path);
              store.dispatch("asyUpdataConfigReturnPath", vm.$route.path); ///异步提交
              // 进入下一个页面
              vm.$router.push({
                path: "/DeviceManageMain/deviceObjectDetails",
                query: {
                  title: objData.deviceName,
                  deviceId: objData.deviceId,
                  productCode: objData.productCode,
                  pageType: "control",
                  productId: objData.productId,
                  productName: objData.productName
                }
              });
              // this.$showTipsToast(1, "获取成功", true); ////提示框
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    click11FenXiangBtnHandle(objData) {
      //设备分享页面被点击了
      console.log("设备分享按钮被点击了");
      if (
        publicDeviceTypeJudge(
          objData.productCode,
          "04",
          "07",
          "08",
          "012",
          "013",
          "015",
          "016",
          "017",
          "018",
          "019",
          "022",
          "023",
          "024",
          "025",
          "026",
          "027",
          "028"
        )
      ) {
        this.$toast("该设备暂时不支持分享~");
        return;
        // 暂时不支持的分享设备
        //
        // PRODUCT_04("04", "四路干接点安防模块"),
        // PRODUCT_07("07", "豪力士指纹门锁"), PRODUCT_08("08","modbus协议空调"),
        //   PRODUCT_12("012", "音乐"),
        // PRODUCT_13("013", "安防控制"),  PRODUCT_15("015", "A0电机控制"),
        // PRODUCT_16("016", "三合一八键环境面板"),PRODUCT_17("017", "A地暖控制"), PRODUCT_18("018", "A新风控制"),
        // PRODUCT_19("019", "环境探测器"),
        // PRODUCT_22("022", "A定时控制"), PRODUCT_23("023", "F路影视控制"), PRODUCT_24("024", "A音乐控制"),
        // PRODUCT_25("025", "F双色控制"), PRODUCT_26("026", "F三色控制"), PRODUCT_27("027", "W1智能插座"),
        // PRODUCT_28("028", "W2智能插座")
      }
      this.$closeTipsToast(); ///关闭之前的toast控制弹窗

      console.log(objData);

      this.$showTipsToast(17, objData);
    },
    click12AddBtnHandle(objData, index) {
      ///删除A类按键 接口，获取数据
      this.$request({
        method: "post",
        url: "/device/deleteDeviceById",
        data: {
          token: store.state.token,
          deviceId: objData[index].deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果
            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            this.$closeTipsToast(); ///关闭toast控制弹窗
            // let aObjectList = store.state.configinfo.oneHostDeviceListData; ///仓库拿到场景规则LIST
            objData.splice(index, 1); ///删除
            this.$showTipsToast(1, "删除成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    determine13BtnHandle() {
      console.log("222222222");
      if (this.userpassWord === "") {
        this.$toast("密码不能为空！");
        return;
      }
      console.log(this.objData);
      /// 设置设备是否开机密码保护接口，获取数据
      this.$request({
        method: "post",
        url: "/device/updateDevicePwdStateById",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId,
          password: this.userpassWord,
          passwordState: Number(!this.objData.passwordState)
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.$closeTipsToast(); ///关闭toast控制弹窗
            this.objData.passwordState = !this.objData.passwordState;
            // this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "设置成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    click14FenXiangBtnHandle(objData) {
      ///场景的分享按钮
      console.log("场景的分享按钮被点击了");
      this.$closeTipsToast(); ///关闭之前的toast控制弹窗

      this.$showTipsToast(17, objData); ////打开新的toast
      console.log(objData);
    },
    click14ConfigBtnHandle(objData) {
      //场景的配置按钮
      console.log("场景的配置按钮被点击了");
      this.$closeTipsToast(); ///关闭toast控制弹窗

      ///下面是为了从设置页面返回到进入页面所以需要存一下路径
      console.log(vm.$route.path);
      store.dispatch("asyUpdataConfigReturnPath", vm.$route.path); ///异步提交

      store.dispatch("asyUpdataOneSceneinfo", objData);
      //代号 20231207-1
      vm.$router.push({ path: '/ConfigSceneMain/ConfigAddScene', query: { title: '修改一个场景' } })
    },
    click15QueRenBtnHandle() {
      // 删除周期定时数据 接口，获取数据
      this.$request({
        method: "post",
        url: "/device/delCycleTimeById",
        data: {
          token: store.state.token,
          cycleId: this.objData[this.index].cycleId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSceneData = res.data.data; ////拿到服务器返回的数据结果
            /// 弹窗的取消按钮
            this.$closeTipsToast(); ///关闭toast控制弹窗
            // this.ServeSceneData = store.state.configinfo.ServeSceneData
            this.objData.splice(this.index, 1);
            this.$showTipsToast(1, "删除成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    determine16BtnHandle() {
      console.log("222222222");
      if (this.userpassWord === "") {
        this.$toast("密码不能为空！");
        return;
      }
      console.log(this.objData);
      /// 设置设备是否开机密码保护接口，获取数据
      this.$request({
        method: "post",
        url: "/device/updateDevicePwdStateById",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId,
          password: this.userpassWord,
          passwordState: this.objData.passwordState
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.$closeTipsToast(); ///关闭toast控制弹窗
            this.objData.checked = !this.objData.checked;
            // this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "操作成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    fenXiangPassWordState017BtnHandle() {
      console.log("s设置分享密码状态的按钮被点击了");
      if (this.fenXiang017.passWordState === 1) {
        ///不设密码
        this.fenXiang017.passWordState = 0;
        this.fenXiang017.passWord = "";
      } else {
        ///设置密码
        this.fenXiang017.passWordState = 1;
        this.fenXiang017.passWord = "";
      }
    },
    fenXiang17QueRenBtnHandle() {
      console.log("创建分享链接确认被点击了");
      if (this.fenXiang017.passWordState === 1) {
        ////说明开启了密码密码验证，对密码进行检查是否合法
        if (this.fenXiang017.passWord.length < 4) {
          this.$toast("分享密码最少4位！");
          return;
        } else if (this.fenXiang017.passWord.length > 24) {
          this.$toast("分享密码最多24位！");
          return;
        } else if (this.fenXiang017.passWord.indexOf(" ") != -1) {
          ///判断字符串中是否包含空格
          console.log(this.fenXiang017.passWord);
          this.$toast("密码中不能包含空格！");
          return;
        }
      }
      ///准备入参
      let shareData = {
        token: store.state.token,
        businessId: "",
        productCode: "",
        day: this.fenXiang017.day,
        hour: this.fenXiang017.hour,
        password: this.fenXiang017.passWord, ///不设密码时密码传空
        passwordState: this.fenXiang017.passWordState
      };
      console.log(this.objData);
      ////开始业务逻辑处理,准备分享数据
      if (this.objData.sceneId) {
        ///说明分享的是场景
        console.log("说明分享的是场景");
        shareData.businessId = this.objData.sceneId;
        shareData.productCode = "099"; ////场景定义为099
      } else {
        ////说明是普通设备
        console.log("说明分享的是设备");
        shareData.businessId = this.objData.deviceId;
        shareData.productCode = this.objData.productCode;
        if (
          publicDeviceTypeJudge(this.objData.productCode, "03", "09", "020")
        ) {
          ////如果是 4键  8键  或F键  需要修改一个入参
          shareData.businessId = this.objData.productId;
          console.log("分享的是面板类的设备");
        }
      }
      console.log(shareData);

      // 创建分享 接口
      this.$request({
        method: "post",
        url: "/share/createShare",
        data: shareData
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data.data);
            // console.log(res.data.data.url)
            let fenXiang017Link = res.data.data.url; ////拿到服务器返回的数据结果

            this.$closeTipsToast(); ///关闭之前的toast控制弹窗
            this.$showTipsToast(18, fenXiang017Link); ////打开新的toast，并传递获得的分享链接
            // this.$showTipsToast(1, '删除成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    doCopy(data) {
      // this.dataProcessing(val)
      console.log("复制到粘贴板");

      this.$copyText(data)
        .then(res => {
          console.log(res);
          this.$toast("已复制到粘贴板~", 3000);
          // alert('Copied')
        })
        .catch(err => {
          console.log(err);
          console.log("浏览器限制未能自动复制");
          // this.$toast('未能复制到粘贴板~', 4000)
          // alert('Can not copy')
        });
    },
    imgFenXiangBtnHandle(data) {
      console.log("分享图标被点击了");
      console.log(data);
      this.$toast("暂未开放~");
    },
    click19QueRenBtnHandle(objData) {
      /// 修改产品基础信息如昵称 接口
      if (this.type === 19) {
        this.$request({
          method: "post",
          url: "/product/updateProductById",
          data: {
            token: store.state.token,

            productId: objData.productId,
            address: objData.address,
            remark: objData.remark
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTips1Toast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              ////、控制成功了
              this.backgroundClickHandle(); //关闭当前提示框

              // // 代号 20241212-1
              // else
              if (objData.type === 'onLinechangeAddress') {
                objData.oneHostDeviceListData.onLineList[objData.Cindex].address =
                  objData.address;
                objData.oneHostDeviceListData.onLineList[objData.Cindex].borderInnerAddress =
                  objData.borderInnerAddress;
                objData.oneHostDeviceListData.onLineList[objData.Cindex].remark =
                  objData.remark;
                objData.oneHostDeviceListData.onLineList[objData.Cindex].errorInfo = "";
              }
              else if (objData.type === 'offLinechangeAddress') {

                objData.oneHostDeviceListData.offLineList[objData.Cindex].address =
                  objData.address;
                objData.oneHostDeviceListData.offLineList[objData.Cindex].borderInnerAddress =
                  objData.borderInnerAddress;
                objData.oneHostDeviceListData.offLineList[objData.Cindex].remark =
                  objData.remark;
                objData.oneHostDeviceListData.offLineList[objData.Cindex].errorInfo = "";
                //取出数据
                let deviceObj = objData.oneHostDeviceListData.offLineList[objData.Cindex];
                objData.oneHostDeviceListData.onLineList.push(deviceObj); //添加数据 到在线列表
                objData.oneHostDeviceListData.offLineList.splice(objData.Cindex, 1); //删除离线列表的数据

              }

              this.$showTips1Toast(1, "修改成功", true); ////提示框
              // 代号 20241212-1
              if (objData.type === 'offLinechangeAddress' || objData.type === 'onLinechangeAddress') {
                //thread 新增功能,返回 2 页,解决中间页数据异常的问题.
                vm.$router.go(-2);
              }
              else {
                vm.$router.go(-1);
              }

            }
          })
          .catch(error => {
            console.log(error);
          });
      }
      else if (this.type === 21) {
        /// 替换产品接口
        this.$request({
          method: "post",
          url: "/product/saveProductV2",
          data: {
            token: store.state.token,

            gatewayId: objData.gatewayId,
            address: objData.address,
            remark: objData.remark
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTips1Toast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              this.backgroundClickHandle(); //关闭当前提示框

              console.log("????????????????????????" + objData.type)
              if (objData.type === 'onLinereplace') { //在线列表点击进来修改地址的
                //本来就在在线列表中 所以不需要处理
                console.log(res.data.data);
              }
              else if (objData.type === 'offLinereplace') { //离线列表点击进来修改设备地址的
                // 替换成功需要将在线列表数据 移到离线列表中
                //取出数据
                let deviceObj = objData.oneHostDeviceListData.offLineList[objData.Cindex];
                objData.oneHostDeviceListData.onLineList.push(deviceObj); //添加数据 到在线列表
                objData.oneHostDeviceListData.offLineList.splice(objData.Cindex, 1); //删除离线列表的数据

                // 按照失效和没失效排序 没失效在前 正序  排序

              }

              this.$showTips1Toast(1, "替换成功", true); ////提示框

              vm.$router.go(-1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    click22DeletelBtnHandle(objData, index) {
      ///删除一条场景规则的的按钮按下了
      //代号 20231207-1
      console.log(index);
      throttle(function () {
        //点击事件，节流 防抖函数
        this.$closeTipsToast(); ///关闭toast控制弹窗
        let ServeSceneRule = store.state.configinfo.OneGroupRuleList; ///仓库拿到场景规则LIST
        console.log(ServeSceneRule);
        ServeSceneRule.splice(index, 1);

        console.log(ServeSceneRule);
      }, throttleTime);
    },
    clickOk23BtnHandle(objData, index) {
      //代号 20231207-1
      console.log(objData);
      // 删除组信息（组管理页面)
      this.$request({
        method: "post",
        url: "/userGroup/delUserGroupById",
        data: {
          token: store.state.token,
          deviceId: objData.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSceneData = res.data.data; ////拿到服务器返回的数据结果
            /// 弹窗的取消按钮
            this.$closeTipsToast(); ///关闭toast控制弹窗
            this.ServeSceneData = store.state.configinfo.ServeGroupData;
            this.ServeSceneData.splice(index, 1);

            this.$showTipsToast(1, "删除成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    click24QueRenBtnHandle(objData) {
      /// 修改产品基础信息如昵称 接口

      //添加产品(thread 产品)
      this.$request({
        method: "post",
        url: "/product/replaceThreadProduct",
        data: {
          token: store.state.token,

          gatewayId: objData.oneHostData.gatewayId,
          threadIp: objData.threadIp,
          remark: objData.query.remark,
          borderAddress: objData.oneHostData.borderAddress, //必须和主机的边界网关地址一致
          borderInnerAddress: objData.query.address
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了,
            return;
          } else {
            ////、控制成功了
            this.backgroundClickHandle(); //关闭当前提示框
            //找到并移除已经添加过的新产品
            for (let i = 0; i < objData.oneHostDeviceListData.threadNewProductList.length; i++) {
              if (objData.oneHostDeviceListData.threadNewProductList[i].threadIp == objData.threadIp) {
                //移除已经添加过的数据
                objData.oneHostDeviceListData.threadNewProductList.splice(i, 1);
              }
            }


            //清空错误信息,保存替换前的产品
            let deviceObj = objData.oneHostDeviceListData.offLineList[objData.query.Cindex];
            deviceObj.errorInfo = "";
            deviceObj.borderAddress = objData.oneHostData.borderAddress
            //增加替换后上线的产品
            objData.oneHostDeviceListData.onLineList.push(deviceObj);
            //删除替换前下线的产品
            objData.oneHostDeviceListData.offLineList.splice(objData.query.Cindex, 1);
            // this.oneHostDeviceListData.onLineList = res.data.data.onLineList;
            vm.$store.dispatch(
              "asyUpdataoneHostDeviceListData",
              objData.oneHostDeviceListData
            ); ///异步提交信息到仓库

            this.$showTipsToast(1, "替换成功", true); ////提示框
            // this.$router.go(-2);
            vm.$router.go(-2);
          }
        })
        .catch(error => {
          console.log(error);
        });

    },
    // ------------------------------------------
  },
  mounted() {
    if (this.type === 18) {
      ////将生成的链接自动复制到粘贴版
      this.$nextTick(() => {
        // console.log(this.shareLink)
        // console.log(this.objData)
        this.shareLink = this.objData;
        //自动复制到粘贴板 部分浏览器处于安全考虑，可能不能自动复制，需手动点击
        this.doCopy(this.shareLink);
      });
    }
  }
};
</script>
<style scoped>
.background_wraper_mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

/* .tips_wrap {
  position: fixed;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  z-index: 20;
} */
/* 激活时的背景 */

.click_tips_background_active {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.3); */
  z-index: 21;
  cursor: pointer;
}

/* 不激活时的背景 */

.click_tips_background {
  z-index: -1;
}

.tips_baidi {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  border-radius: 5px;
  /*  //代号 20231116-1 */
  padding: 0 20px;
  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* position: relative; */
  z-index: 25;
}

.tips_fenxiang_20_tips {
  /* background-color: #f5f5f5; */
  border-radius: 5px;
  width: 100%;
  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  z-index: 25;
}

.tips_fenxiang_20_tips_title {
  margin-bottom: 10px;

  color: #ffffff;
  font-size: 20px;
}

.content_text_20_tishi_wraper {
  margin: 20px 40px;
}

.tips_fenxiang_20_tips_content {
  margin-top: 20px;
  color: #dddddd;
  font-size: 16px;
}

.tips_fenxiang_20_tips_content_text {
  color: #ffffff;
  font-size: 14px;
  /* 文字内容可复制 */
  -moz-user-select: text;
  /* Firefox私有属性 */
  -webkit-user-select: text;
  /* WebKit内核私有属性 */
  -ms-user-select: text;
  /* IE私有属性(IE10及以后) */
  -khtml-user-select: text;
  /* KHTML内核私有属性 */
  -o-user-select: text;
  /* Opera私有属性 */
  user-select: text;
  /* CSS3属性 */
}

.close_img {
  margin-top: 20px;
  width: 40px;
  height: 40px;
}

.tips_baidi>img {
  display: inline-block;
  height: 40px;
  width: 40px;
}

.tips_baidi_text {
  align-content: center;
  font-size: 14px;
  display: inline-block;
}

.tips_huidi {
  width: 200px;
  height: 200px;
  background-color: #909399;
}

.tips_queren_fanhui {
  width: 330px;
  height: 180px;
  background: rgba(33, 33, 33, 0.9);
  padding: 20px;
  border-radius: 8px;

  color: #f5f5f5;
  font-size: 18px;
  /* max-width: 400px; */
  cursor: pointer;

  /* z-index: 22; */
}

.tips_fenxiang_17_tips {
  width: 330px;
  height: 380px;
  background: rgba(33, 33, 33, 0.9);
  padding: 20px;
  border-radius: 8px;

  color: #f5f5f5;
  font-size: 18px;
  /* max-width: 400px; */
  cursor: pointer;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.tips_fenxiang_18_tips {
  width: 380px;
  height: 260px;
  background: rgba(33, 33, 33, 0.9);
  padding: 20px;
  border-radius: 8px;

  color: #f5f5f5;
  font-size: 18px;
  /* max-width: 400px; */
  cursor: pointer;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.scene_control_page {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  /* align-content: center; */
  align-items: center;
}

.tips_queren_fanhui_title {
  font-size: 20px;
  margin: 10px 0;
  width: 100%;
  text-align: center;
}

.tips_queren_fanhui_name {
  width: 100%;
  color: #999999;
  margin: 10px 0;
  text-align: center;
}

.tips_queren_fanhui_btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  margin: 20px 0;
}

.tips_btn {
  flex: 1;
  margin: 0px 25px;
  background: #f5f5f5;
  color: #282828;
}

.tips_btn:active {
  background: #a0a3a5;
  /* border: 0px solid #a0a3a5; */
}

/* 类型6的样式 */
.tips_toast6_wraper {
  width: 300px;
  min-height: 300px;
  max-height: 500px;
  background-color: #ffffff;
  border-radius: 10px;
  /* box-sizing: border-box; */
  /* padding-bottom: 21px; */

  box-shadow: 1px 1px 5px 5px rgba(33, 33, 33, 0.1);

  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  z-index: 25;
}

.tips_toast6_context {
  width: 300px;
  max-height: 270px;
  /* 火狐浏览器滚动条隐藏 */
  overflow: auto;
  overflow-y: scroll;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
}

/* 进度条隐藏 */
.tips_toast6_context::-webkit-scrollbar {
  display: none;
}

.tips_toast6_wraper img {
  width: 300px;
  height: 100px;
}

.tips_toast_6_hang {
  box-sizing: border-box;
  padding: 0px 20px;
  width: 100%;
  margin: 2px 0px;
  color: #666666;
}

.tips_toast6_title {
  position: absolute;

  top: 20px;
  left: 50%;
  transform: translate(-50%, 0%);
  text-align: center;

  color: #ffffff;
  font-size: 18px;
}

.tips_toast6_text {
  box-sizing: border-box;
  padding: 0px 20px;
  width: 100%;

  color: #282828;
  font-size: 16px;

  margin-top: 10px;
}

.tips_toast6_btn {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: var(--primary-color);

  margin: 26px 50px;
  border-radius: 5px;
  color: #ffffff;
  font-size: 16px;
}

.tips_toast6_btn:active {
  background: #a0a3a5;
  /* border: 0px solid #a0a3a5; */
}

.tips11_left_fen_xiang {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;

  font-size: 18px;
}

.tips_11_wraper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}

.tips_11_wraper div img {
  width: 90px;
  height: 90px;

  margin-bottom: 10px;
}

.device_config_013_mi_ma_yan_zheng {
  width: 280px;
  background-color: #666666;
  border: #666666;
  color: #f5f5f5;

  margin-top: 15px;
  margin-bottom: 5px;
}

.device_config_013_mi_ma_yan_zheng:focus {
  border: #666666;
  color: #f5f5f5;
}

.btn_config_013 {
  margin: 0px 10px;
}

.tips1_baidi {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  border-radius: 5px;

  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* position: relative; */
  z-index: 25;
}

.tips1_baidi img {
  display: inline-block;
  height: 40px;
  width: 40px;
}

.tips1_baidi_text {
  align-content: center;
  font-size: 14px;
  display: inline-block;
}

.tips1_huidi {
  width: 250px;
  height: 150px;
  background-color: #f5f5f5;
  box-shadow: 1px 1px 5px 5px rgba(33, 33, 33, 0.1);

  color: #666666;

  box-sizing: border-box;
  padding: 20px;
  /* justify-content: flex-start; */
}

.tips1_huidi img {
  /* margin-top: 20px; */
  margin-bottom: 10px;
}

.tips_fenxiang_17_tishi {
  color: #999999;
  font-size: 14px;
}

.tips_fenxiang_17_tips_jiami {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #f5f5f5;
  font-size: 16px;
  margin-top: 10px;
}

.tips_fenxiang_17_tips_jiami>img {
  width: 21px;
  height: 21px;
}

.tips_fenxiang_17_tips_jiami_input {
  width: 97%;
  margin: 2px 0px;
}

.tips_fenxiang_17_tips_time {
  width: 100%;
  font-size: 16px;
  color: #f5f5f5;
  margin: 20px 0px;
}

.tips_fenxiang_17_tips_time_input>input {
  width: 40px;
}

.tips_fenxiang_17_tips_time_tips {
  height: 40px;
  line-height: 40px;
}

.chuang_jian_fen_xiang17_btn {
  height: 47px;
  line-height: 47px;
  margin: 25px 0px 0px 0px;
  width: 100%;
}

.chuang_jian_fen_xiang18_btn {
  height: 28px;
  line-height: 28px;
  margin: 0px 5px 0px 0px;
  width: 60px;
  font-size: 14px;
}

.tips_fenxiang_18_link_info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid #666666;
  border-radius: 5px;
}

.tips_fenxiang_18_link_info>img {
  height: 21px;
  width: 21px;
  margin: 0px 3px;
}

div>.tips_fenxiang_18_link_info>input {
  background-color: transparent;
  font-size: 18px;
  color: #999999;

  padding: 7px 0px;
}

.tips_fenxiang_18_tishi {
  margin-top: 10px;
  margin-bottom: 4px;

  color: #999999;
  font-size: 14px;
  align-self: flex-start;
}

.tips_fenxiang_18_fengexian {
  margin: 30px 0px;
  width: 100%;
  height: 1px;
  background-color: #666666;
}

.tips_fenxiang_18_fengexian_img_wraper {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.tips_fenxiang_18_fengexian_img_wraper>img {
  width: 45px;
  height: 45px;
}

.appdownload2_20_img {
  border: 5px;
  margin-top: 20px;
  width: 200px;
  height: 200px;
}

.appdownload2_20_text {
  margin-top: 10px;
  font-size: 16px;
  color: #ffffff;
}

.appdownload2_20_wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.botton_20_appdown_wraper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  /* ///	背景深色渐变 */
  /* background: linear-gradient( #0000FF,rgb(161, 145, 231));
  background: -webkit-linear-gradient( #0000FF,rgb(161, 145, 231));
  background: -o-linear-gradient( #0000FF,rgb(161, 145, 231));
  background: -moz-linear-gradient( #0000FF,rgb(161, 145, 231)); */
  /* ///	背景浅色渐变 */
  background: linear-gradient(var(--primary-color), rgb(161, 145, 231));
  background: -webkit-linear-gradient(var(--primary-color), rgb(161, 145, 231));
  background: -o-linear-gradient(var(--primary-color), rgb(161, 145, 231));
  background: -moz-linear-gradient(var(--primary-color), rgb(161, 145, 231));

  /* 圆角设置 
  border-radius: 5px;
  /* 属性说明（顺序依次对应）：
  阴影的X轴(可以使用负值) 阴影的Y轴(可以使用负值) 阴影模糊值（大小） 阴影的颜色
  默认是外阴影
    box-shadow:0 0 7px var(--primary-color) inset;
  内阴影：inset 可以设置成内部阴影 */
  box-shadow: 0 0 4px var(--primary-color);
  padding: 30px 80px;
  border-radius: 8px;
}

/* .
  justify-content:center;
} */
/* 淡入淡出的时间控制 */

/* .tips_fade_in {
  -webkit-animation: fadeIn 0.1s ease;
  -moz-animation: fadeIn 0.1s ease;
  animation: fadeIn 0.1s ease;
} */
</style>
